import React from 'react'
import { themes } from '../../../configs/theme'
import { UseTheme } from '../hooks/useTheme'
import { Element } from '../html/element'
import { Image } from '../image'
import BlackLoading from './blackLoading.gif'
import classes from './index.module.scss'
import WhiteLoading from './whiteLoading.gif'

const loadingSrc = {
  [themes.light]: BlackLoading,
  [themes.dark]: WhiteLoading,
}

export const Loading = ({ style }) => {
  const theme = UseTheme()

  return (
    <Element className={classes.loadingSpinner} style={style}>
      <Image
        src={loadingSrc[theme]}
        alt="loading"
        style={{ width: 35, height: 35 }}
      />
    </Element>
  )
}
